//For more loader 
//https://github.com/mhnpd/react-loader-spinner
//used in Page: TodoList.jsx
import React from 'react';
import { Blocks } from 'react-loader-spinner';
const Spinner = () => {
    const spinnerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'top',
        marginTop: '10vh',
        height: '100vh', // Takes the full height of the viewport
    };

    return (
        <div style={spinnerStyle}>
            <Blocks
                height="80"
                width="80"
                color="#4fa94d"
                ariaLabel="blocks-loading"
                visible={true}
            />
        </div>
    );
};

export default Spinner;
